import React, { useContext, useEffect, useState } from "react";
import styles from "./css/solutionsCard.module.css";
import { IdiomaContext } from './context/IdiomaContext';
import { traducciones } from '../data/solutionsData';
import { useInView } from 'react-intersection-observer';
import { NavLink } from 'react-router-dom';

function SolutionsCard({ id }) {
  const { idioma } = useContext(IdiomaContext);
  const traduccion = traducciones[id][idioma];
  const { ref, inView } = useInView({ threshold: 0.1 });

  const [backgroundColor, setBackgroundColor] = useState("");

  useEffect(() => {
    const colores = ['#a9c8d3', '#d3f3a9', '#f3d3a9', '#a9d3f3']; // Modo claro
    const coloresDark = ['#0F6391', '#434648', '#8a4646', '#637a65', '#7a5b7a']; // Modo oscuro

    const updateBackgroundColor = () => {
      const isDarkMode = document.body.classList.contains('dark-mode');
      const coloresUsar = isDarkMode ? coloresDark : colores;
      const colorAleatorio = coloresUsar[Math.floor(Math.random() * coloresUsar.length)];
      setBackgroundColor(colorAleatorio);
    };

    updateBackgroundColor(); // Llamar a la función al inicio

    // Escuchar cambios en el modo nocturno
    const observer = new MutationObserver(updateBackgroundColor);
    observer.observe(document.body, { attributes: true });

    return () => {
      observer.disconnect(); // Limpiar el observer al desmontar
    };
  }, []); // Dependencias vacías para que solo se ejecute una vez

  if (!traduccion) return null;

  return (
    <div className={styles.container}>
      <div
        className={`${styles.container__layout} ${inView ? styles.fadeIn : styles.fadeOut}`}
        style={{ backgroundColor }}
      >
        <div
          className={styles.layout}
          ref={ref}
        >
          <div className={styles.About}>
            <h1 className={styles.layout__title}>{traduccion.title}</h1>

            <div className={styles.profileAbout}>
              <div className={styles.projectData}>
                <img
                  src={traduccion.imageUrl}
                  alt={traduccion.title2}
                  className={styles.image}
                />
                <h2 className={styles.textProject}>{traduccion.title2}</h2>

                <div className={styles.textDescription}>
                  {traduccion.description}
                </div>
                <div className={styles.textDescription}>
                  {traduccion.description2}
                </div>
                <div className={styles.textDescription}>
                  {traduccion.description3}
                </div>

                <hr className={styles.hrBar} />

                <div className={styles.textBox}>
                  <div className={styles.textDescription}>
                    <ul className={styles.customList}>
                      {traduccion.list1 && <li className={styles.textList}>{traduccion.list1}</li>}
                      {traduccion.list2 && <li className={styles.textList}>{traduccion.list2}</li>}
                      {traduccion.list3 && <li className={styles.textList}>{traduccion.list3}</li>}
                      {traduccion.list4 && <li className={styles.textList}>{traduccion.list4}</li>}
                      {traduccion.list5 && <li className={styles.textList}>{traduccion.list5}</li>}
                    </ul>
                    {traduccion.description4}
                  </div>
                  <img
                    src={traduccion.imageUrl2}
                    alt={traduccion.title2}
                    className={styles.image}
                  />
                </div>

                <div className={styles.textProject}>
                  {traduccion.textTecnology}
                </div>

                <div className={styles.botton_Url}>
                  <NavLink to={traduccion.url} className={styles.text_Url}>
                    {traduccion.textUrl}
                  </NavLink>
                </div>
                
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SolutionsCard;
